import Vue from 'vue'
import { mapGetters, mapState, mapActions } from 'vuex'

import QuizStatuses from '@/constant/QuizStatuses'
import shuffleArrayWithSeed from '@/utils/shuffleArrayWithSeed'

export default (CategoriseContentView) => Vue.component('CategoriseContentViewController', {
  props: {
    hideBlankCategories: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapGetters({
      categories: 'categorise/slideActiveCategories',
    }),
    ...mapGetters('liveStatsV2', [
      'correctAnswerCountPerActivity',
      'incorrectAnswerCountPerActivity',
      'correctAnswerCountPerAnswerValue',
      'incorrectAnswerCountPerAnswerValue',
      'correctAnswerCountPerActivityV2',
      'incorrectAnswerCountPerActivityV2',
      'correctAnswerCountPerAnswerValueV2',
      'incorrectAnswerCountPerAnswerValueV2',
    ]),

    ...mapState({
      slideActive: (state) => state.slideActive,
      userOnline: (state) => state.userOnline,
      isSharingView: (state) => state.sharePresentation,
    }),
    correctedAnswerPerSlide() {
      return this.correctAnswerCountPerActivity(this.slideActive.id, this.slideActive.version) +
        this.correctAnswerCountPerActivityV2(this.slideActive.id, this.slideActive.version)
    },
    incorrectedAnswerPerSlide() {
      return this.incorrectAnswerCountPerActivity(this.slideActive.id, this.slideActive.version) +
        this.incorrectAnswerCountPerActivityV2(this.slideActive.id, this.slideActive.version)
    },
    correctAnswerCountPerOption() {
      return (category, option) => {
        const answerValue = `${category.value}*|*${option.value}`
        return this.correctAnswerCountPerAnswerValue(this.slideActive.id, this.slideActive.version, 0, answerValue) +
          this.correctAnswerCountPerAnswerValueV2(this.slideActive.id, this.slideActive.version, 0, answerValue)
      }
    },
    incorrectAnswerCountPerOption() {
      return (category, option) => {
        const answerValue = `${category.value}*|*${option.value}`
        return this.incorrectAnswerCountPerAnswerValue(this.slideActive.id, this.slideActive.version, 0, answerValue) +
          this.incorrectAnswerCountPerAnswerValueV2(this.slideActive.id, this.slideActive.version, 0, answerValue)
      }
    },
    isPresentingOrBackstage() {
      return this.isPresenting || this.isBackstage
    },
    isShowOptions() {
      return (this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN && this.isPresentingOrBackstage) ||
        this.isSharingView
    },
    isShowCorrectAnswer() {
      return (this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN && this.isPresentingOrBackstage) ||
        this.isSharingView
    },
    options() {
      if (!this.categories) return []
      const options = this.categories.reduce((acc, category) => {
        const optionsValues = category.options.map((option) => option.value)
        return [...acc, ...optionsValues]
      }, [])

      return shuffleArrayWithSeed(options, this.slideActive.id).map((option) => ({ value: option }))
    },
    showedCategories() {
      let categories = this.isShowOptions
        ? this.categories
        : this.categories.map((category) => ({ value: category.value, options: [] }))
      if (!this.hideBlankCategories) return categories
      categories = categories.filter((category) => category.value.trim())
      return categories
    },
    totalAnswersPerSlide() {
      const correctAnswer = this.correctedAnswerPerSlide || 0
      const incorrectAnswer = this.incorrectedAnswerPerSlide || 0
      return correctAnswer + incorrectAnswer
    },
  },
  watch: {
    totalAnswersPerSlide(value) {
      const multipleCountAnswer = Number(value)
      const payload = { multipleCountAnswer }
      this.updateSlideActiveAction(payload)
    },
  },
  mounted() {
    this.subscribeCategoriseStatsAction(this.slideActive)
  },
  methods: {
    ...mapActions('categorise', [
      'subscribeCategoriseStatsAction',
    ]),
    ...mapActions(['updateSlideActiveAction']),
  },

  render(createElement) {
    return createElement(CategoriseContentView, {
      props: {
        categories: this.showedCategories,
        options: this.options,
        slideActive: this.slideActive,
        isPresentingOrBackstage: this.isPresentingOrBackstage,
        correctedAnswerPerSlide: this.correctedAnswerPerSlide,
        incorrectedAnswerPerSlide: this.incorrectedAnswerPerSlide,
        correctAnswerCountPerOption: this.correctAnswerCountPerOption,
        incorrectAnswerCountPerOption: this.incorrectAnswerCountPerOption,
        isShowCorrectAnswer: this.isShowCorrectAnswer,
      },
    })
  },
})
